
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth } from './services/firebase-config';
import { signInAnonymously } from 'firebase/auth';
import Navigation from './components/Navigation';
import CreateStoryPage from './pages/CreateStoryPage';
import LibraryPage from './pages/LibraryPage';
import StoryViewPage from './pages/StoryViewPage';
import LoadingSpinner from './components/LoadingSpinner';
import { ROUTES } from './routes';
import './App.css';

function App() {
  const [loading, setLoading] = useState(true);
  const [authInitialized, setAuthInitialized] = useState(false);

  useEffect(() => {
    const initializeAuth = async () => {
      try {
        await signInAnonymously(auth);
        setAuthInitialized(true);
      } catch (error) {
        console.error("Error initializing anonymous authentication:", error);
      } finally {
        setLoading(false);
      }
    };

    initializeAuth();
  }, []);

  if (loading) {
    return (
      <div className="loading-container">
        <LoadingSpinner message="Loading StorySparkle..." />
      </div>
    );
  }

  return (
    <Router>
      <div className="app">
        <Navigation />
        <main className="main-content">
          <Routes>
            <Route path={ROUTES.CREATE} element={<CreateStoryPage />} />
            <Route path={ROUTES.LIBRARY} element={<LibraryPage />} />
            <Route path={`${ROUTES.STORY}/:storyId`} element={<StoryViewPage />} />
            <Route path="/" element={<Navigate to={ROUTES.CREATE} replace />} />
          </Routes>
        </main>
        <footer className="footer">
          <p>StorySparkle - Enchanting tales for children of all ages</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;